import { createFileRoute } from '@tanstack/react-router'
import { parseMatchDetailSearch } from '~/features/football-match-detail/back-navigation'
import { FootballMatchDetailRouteModule } from '~/features/football-match-detail/route-module'
import {
  loadFootballMatchDetailRoute,
  validateFootballMatchDetailRouteParams,
} from '~/features/football-match-detail/route-options'
import { seo } from '~/utils/seo'

export const Route = createFileRoute('/matches/$matchId')({
  validateSearch: search => parseMatchDetailSearch(search, 'en'),
  beforeLoad: ({ params }) => validateFootballMatchDetailRouteParams(params),
  head: ({ params }) => seo({
    title: 'Football Match Detail | BallPeek',
    description: 'Score-first football facts, lineups, player links, history, and reviewed context.',
    pathname: `/matches/${encodeURIComponent(params.matchId)}`,
    locale: 'en',
  }),
  loader: loadFootballMatchDetailRoute,
  component: MatchDetailRoute,
})

function MatchDetailRoute() {
  const { matchId } = Route.useParams()
  return (
    <FootballMatchDetailRouteModule
      matchId={matchId}
      locale="en"
      back={Route.useSearch().back}
    />
  )
}
